import React, { createContext, useContext, useEffect, useState } from 'react';
import YAML from 'yaml';

import localeEn from './assets/locales/locale_en.yaml';
import localeZh from './assets/locales/locale_zh.yaml';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    return localStorage.getItem('locale') || 'en';
  });
  const [translations, setTranslations] = useState(null);

  useEffect(() => {
    Promise.all([fetch(localeEn), fetch(localeZh)])
      .then(([en_res, zh_res]) => {
        Promise.all([en_res.text(), zh_res.text()])
          .then(([en_text, zh_text]) => {
            const en_parsed = YAML.parse(en_text);
            const zh_parsed = YAML.parse(zh_text);
            setTranslations({ en: en_parsed, zh: zh_parsed });
          })
          .catch((err) => console.error('Error loading translations:', err));
      })
      .catch((err) => console.error('Error loading translations:', err));
  }, []);

  const toggleLocale = () => {
    setLocale((prev) => {
      const next = prev === 'en' ? 'zh' : 'en';
      localStorage.setItem('locale', next);
      return next;
    });
  };

  const t = (key, variables = {}) => {
    if (!translations || !translations[locale]) {
      // Fallback simple translation until loaded
      return key;
    }

    const keys = key.split('.');
    let value = translations[locale];
    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) break;
    }

    if (typeof value !== 'string') return key;

    let result = value;
    Object.entries(variables).forEach(([k, v]) => {
      result = result.replace(new RegExp(`{${k}}`, 'g'), String(v));
    });
    return result;
  };

  return (
    <LanguageContext.Provider
      value={{ locale, toggleLocale, t, isLoading: !translations }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return ctx;
}
